import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { PageLinksWidget } from 'site-modules/shared/components/page-links-widget/page-links-widget';

export const PageLinksWidgetEntry = memo(props => {
  const { entry } = props;

  return <PageLinksWidget className="mt-1_5" creativeId={entry.metadata('creative-id').value()} />;
});

PageLinksWidgetEntry.displayName = 'PageLinksWidgetEntry';
PageLinksWidgetEntry.propTypes = {
  entry: PropTypes.shape({
    metadata: PropTypes.func.isRequired,
  }).isRequired,
};
